export type UrlType = 'url' | 'subdomain' | 'page';

export type UrlTargetType = '_blank' | '_self' | '_parent' | '_top' | string;

export const UrlTarget = {
    blank: '_blank',
    self: '_self',
    parent: '_parent',
    top: '_top',
};